/*
 * @Author: Yang Zhang
 * @Date: 2022-06-08 18:36:47
 * @LastEditors: Yang Zhang
 * @LastEditTime: 2022-06-20 11:02:03
 * @Description:
 */
import axios, { AxiosRequestConfig } from 'axios'
import { message } from 'ant-design-vue'

const instance = axios.create()
instance.interceptors.response.use(
  (res) => res,
  (err) => {
    const res = err.response
    const errTips = res?.data?.data?.errorMsg || '出错了'

    message.error(errTips)
    return Promise.reject(err)
  }
)

export function simpleRequest<T>(opts: AxiosRequestConfig) {
  return instance.request<T>(opts)
}
